import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import { useCompassCard } from '@scale/compass-ui/store';
import { JoinCardInstructions } from './JoinCardInstructions';
import { JoinTable } from './components/JoinTable';
import {
  JoinWorkerIdColumns,
  JoinTaskIdColumns,
} from '@scale/genai-compass-shared/cards/join_additional_data/columns';
import type { JoinContext } from '@scale/genai-compass-shared/cards/join_additional_data/card';
import type { ExportSource } from '@scale/genai-compass-shared/cards/join_additional_data/types';

const JoinCardComponent: CompassCardComponent = ({ index }: CompassCardComponentProps) => {
  const { card, updateCardContext } = useCompassCard(index);
  const context = card.defaultContext as JoinContext;
  const { retrievedOutput } = useCompassCard(index - 1);
  const { columnsToJoin } = context;

  const handleSelectionChange = (
    selectedKeys: {
      column: JoinWorkerIdColumns | JoinTaskIdColumns;
      source: ExportSource | string;
    }[],
  ) => {
    const updatedContext: JoinContext = {
      ...context,
      columnsToJoin: selectedKeys,
    };
    updateCardContext(updatedContext);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="w-full">
        <JoinCardInstructions />
      </div>
      <div className="w-full">
        <JoinTable
          columnsToJoin={columnsToJoin}
          onSelectionChange={handleSelectionChange}
          columns={retrievedOutput?.response?.schema || []}
        />
      </div>
    </div>
  );
};

export default JoinCardComponent;
